@if (matcher$ | async; as matcher) {
  <div class="layout-col">
    <app-material-matcher-detail class="flex" [matcher]="matcher.materialMatcher">
    </app-material-matcher-detail>
    <elder-label-input
      name="allowedLabels"
      label="{{ 'materials.allowed-labels' | translate }}"
      [(value)]="matcher.allowedLabels"
    >
    </elder-label-input>
  </div>
}
